var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup58671(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58671",
    "data-name": "Group 58671",
    transform: "translate(-20740.961 -3391.166)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4487",
    "data-name": "Ellipse 4487",
    cx: 48,
    cy: 48,
    r: 48,
    transform: "translate(20740.961 3391.166)",
    fill: "#d9e7f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "duplicate_1_",
    "data-name": "duplicate (1)",
    transform: "translate(20769.041 3413.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86427",
    "data-name": "Path 86427",
    d: "M121.817,12.7V40.818a1.405,1.405,0,0,1-1.428,1.381H92.541a1.4,1.4,0,0,1-1.428-1.381V1.381A1.4,1.4,0,0,1,92.541,0h16.138a1.469,1.469,0,0,1,.591.124,1.419,1.419,0,0,1,.419.28L121.4,11.724a1.392,1.392,0,0,1,.289.4A1.342,1.342,0,0,1,121.817,12.7Zm0,0",
    transform: "translate(-81.978)",
    fill: "rgba(0,92,163,0.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86429",
    "data-name": "Path 86429",
    d: "M284.632,13.243h-10.99a1.4,1.4,0,0,1-1.428-1.381V1.238a1.419,1.419,0,0,1,.419.28l11.709,11.32A1.393,1.393,0,0,1,284.632,13.243Zm0,0",
    transform: "translate(-244.922 -1.114)",
    fill: "#005ca3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86430",
    "data-name": "Path 86430",
    d: "M30.7,103.814v28.117a1.4,1.4,0,0,1-1.428,1.381H1.428A1.4,1.4,0,0,1,0,131.931V92.494a1.4,1.4,0,0,1,1.428-1.381H17.566a1.467,1.467,0,0,1,.591.124,1.412,1.412,0,0,1,.419.28l11.709,11.32a1.4,1.4,0,0,1,.289.4A1.339,1.339,0,0,1,30.7,103.814Zm0,0",
    transform: "translate(0 -81.978)",
    fill: "#005ca3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86432",
    "data-name": "Path 86432",
    d: "M193.519,104.357H182.53a1.405,1.405,0,0,1-1.428-1.381V92.352a1.412,1.412,0,0,1,.419.28l11.709,11.32A1.4,1.4,0,0,1,193.519,104.357Zm0,0",
    transform: "translate(-162.944 -83.092)",
    fill: "#d9e7f1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup58671);
export default __webpack_public_path__ + "static/media/group_58671.4e0fc6c7ba215fd49246832c81f96a9c.svg";
export { ForwardRef as ReactComponent };